export default __webpack_public_path__ + "static/media/house2large.d11bd27e.png";